if (!window.zsPageNextReady) {
  window.zsPageNextReady = true;
  document.addEventListener('click', function(event) {
    var link = event.target.closest('[data-zs-page-next]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    var target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    event.preventDefault();
    if (!target.hasAttribute("tabindex")) target.setAttribute("tabindex", "-1");
    target.focus({preventScroll:true});
    target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
  });
}
